// import React, { useState, useEffect } from "react";
// import { useAuth } from "./AuthContext";
// import { getMessages } from "../api/conversationsApi";
// import LeadReplyForm from "./LeadReplyForm";
// import {
//   getLeads,
//   getLeadsStats,
//   updateLead,
//   deleteLead,
// } from "../api/leadsApi";
// import {
//   Target, Plus, PhoneCall, PhoneOff, CheckCircle2,
//   Ban, Wallet, Calendar, Building2, Mail, MessageSquare,
//   Trash2, Save, User, RefreshCw,
// } from "lucide-react";

// const STATUSES = [
//   { key: "new",       label: "Новый",         Icon: Plus,         color: "bg-blue-50 border-blue-300",     badge: "bg-blue-100 text-blue-700" },
//   { key: "call",      label: "Позвонить",     Icon: PhoneCall,    color: "bg-yellow-50 border-yellow-300", badge: "bg-yellow-100 text-yellow-700" },
//   { key: "called",    label: "Дозвонился",    Icon: CheckCircle2, color: "bg-green-50 border-green-300",   badge: "bg-green-100 text-green-700" },
//   { key: "no_answer", label: "Не дозвонился", Icon: PhoneOff,     color: "bg-orange-50 border-orange-300", badge: "bg-orange-100 text-orange-700" },
//   { key: "rejected",  label: "Отказ",         Icon: Ban,          color: "bg-red-50 border-red-300",       badge: "bg-red-100 text-red-700" },
//   { key: "deal",      label: "Сделка",        Icon: Wallet,       color: "bg-purple-50 border-purple-300", badge: "bg-purple-100 text-purple-700" },
// ];

// const STATUS_MAP = Object.fromEntries(STATUSES.map(s => [s.key, s]));

// export default function LeadsPage() {
//   const { user } = useAuth();
//   const [leads, setLeads] = useState([]);
//   const [stats, setStats] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [savingId, setSavingId] = useState(null);

//   const [editForm, setEditForm] = useState({
//     status: "new",
//     next_call_at: "",
//     last_comment: "",
//     phone: "",
//   });

//   const loadLeads = async () => {
//     try {
//       setLoading(true);
//       const [leadsRes, statsRes] = await Promise.all([
//         getLeads(),
//         getLeadsStats(),
//       ]);
//       setLeads(leadsRes.data);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка загрузки лидов");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { loadLeads(); }, []);

//   const loadMessagesFor = async (conversationId) => {
//     if (!conversationId) {
//       setMessages([]);
//       return;
//     }
//     setLoadingMessages(true);
//     try {
//       const res = await getMessages(conversationId);
//       setMessages(res.data);
//     } catch (err) {
//       console.error(err);
//       setMessages([]);
//     } finally {
//       setLoadingMessages(false);
//     }
//   };

//   const reloadMessages = () => {
//     if (selectedLead?.conversation_id) {
//       loadMessagesFor(selectedLead.conversation_id);
//     }
//   };

//   const openLead = async (lead) => {
//     setSelectedLead(lead);
//     setEditForm({
//       status: lead.status || "new",
//       next_call_at: lead.next_call_at
//         ? new Date(lead.next_call_at).toISOString().slice(0, 16)
//         : "",
//       last_comment: lead.last_comment || "",
//       phone: lead.phone || "",
//     });
//     loadMessagesFor(lead.conversation_id);
//   };

//   const handleSave = async () => {
//     if (!selectedLead) return;
//     setSavingId(selectedLead.id);
//     try {
//       const res = await updateLead(selectedLead.id, {
//         status: editForm.status,
//         next_call_at: editForm.next_call_at || null,
//         last_comment: editForm.last_comment,
//         phone: editForm.phone,
//       });
//       setLeads(prev => prev.map(l => l.id === selectedLead.id ? { ...l, ...res.data.lead } : l));
//       setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
//       const statsRes = await getLeadsStats();
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка сохранения");
//     } finally {
//       setSavingId(null);
//     }
//   };

//   const handleQuickStatusChange = async (lead, newStatus) => {
//     try {
//       const res = await updateLead(lead.id, { status: newStatus });
//       setLeads(prev => prev.map(l => l.id === lead.id ? { ...l, ...res.data.lead } : l));
//       if (selectedLead?.id === lead.id) {
//         setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
//         setEditForm(f => ({ ...f, status: newStatus }));
//       }
//       const statsRes = await getLeadsStats();
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка смены статуса");
//     }
//   };

// const handleDelete = async (lead) => {
//   if (!window.confirm(`Удалить лид "${lead.contact_email}"? Переписка останется в общих переписках.`)) return;
//     try {
//       await deleteLead(lead.id);
//       setLeads(prev => prev.filter(l => l.id !== lead.id));
//       if (selectedLead?.id === lead.id) setSelectedLead(null);
//       const statsRes = await getLeadsStats();
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка удаления");
//     }
//   };

//   const formatDate = (iso) => {
//     if (!iso) return "—";
//     return new Date(iso).toLocaleString("ru-RU", {
//       day: "2-digit", month: "2-digit",
//       hour: "2-digit", minute: "2-digit",
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-4">
//       <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
//         <h1 className="text-xl md:text-2xl font-bold flex items-center gap-2">
//           <Target size={24} className="text-purple-600" />
//           Лиды (CRM)
//         </h1>
//         <div className="text-sm text-gray-500">
//           Всего: {leads.length}
//         </div>
//       </div>

//       {/* Счётчики по статусам */}
//       <div className="grid grid-cols-2 md:grid-cols-6 gap-2 mb-4">
//         {STATUSES.map(s => {
//           const Icon = s.Icon;
//           return (
//             <div key={s.key} className={`rounded-xl p-2 md:p-3 border ${s.color}`}>
//               <div className="flex items-center gap-1.5 text-[10px] md:text-xs font-medium text-gray-600">
//                 <Icon size={14} className="flex-shrink-0" />
//                 <span className="truncate">{s.label}</span>
//               </div>
//               <div className="text-lg md:text-xl font-bold text-gray-800 mt-1">
//                 {stats[s.key] || 0}
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       <div className="flex flex-col lg:flex-row gap-3">
//         {/* ===== СПИСОК ЛИДОВ ===== */}
//         <div className="w-full lg:w-2/3 space-y-2">
//           {loading && (
//             <div className="text-center text-gray-400 py-8">Загрузка...</div>
//           )}

//           {!loading && leads.length === 0 && (
//             <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500">
//               Пока нет лидов. Откройте переписку и нажмите «В лиды».
//             </div>
//           )}

//           {leads.map(lead => {
//             const StatusIcon = STATUS_MAP[lead.status]?.Icon;
//             return (
//               <div
//                 key={lead.id}
//                 onClick={() => openLead(lead)}
//                 className={`bg-white rounded-2xl shadow-md p-3 md:p-4 cursor-pointer transition border-2 ${
//                   selectedLead?.id === lead.id
//                     ? "border-blue-500"
//                     : "border-transparent hover:border-gray-200"
//                 }`}
//               >
//                 <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2">
//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center gap-2 flex-wrap">
//                       <div className="font-semibold text-gray-800 truncate">
//                         {lead.contact_name || lead.contact_email}
//                       </div>
//                       <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${STATUS_MAP[lead.status]?.badge || "bg-gray-100"}`}>
//                         {StatusIcon && <StatusIcon size={10} />}
//                         {STATUS_MAP[lead.status]?.label || lead.status}
//                       </span>
//                     </div>
//                     {lead.company_name && (
//                       <div className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
//                         <Building2 size={11} className="flex-shrink-0" />
//                         <span className="truncate">{lead.company_name}</span>
//                       </div>
//                     )}
//                     <div className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
//                       <Mail size={11} className="flex-shrink-0" />
//                       <span className="truncate">{lead.contact_email}</span>
//                     </div>
//                     {lead.last_message && (
//                       <div className="text-xs text-gray-400 truncate mt-1 flex items-center gap-1">
//                         <MessageSquare size={11} className="flex-shrink-0" />
//                         <span className="truncate">{lead.last_message}</span>
//                       </div>
//                     )}
//                   </div>

//                   <div className="flex flex-col items-end gap-1 flex-shrink-0">
//                     {lead.next_call_at && (
//                       <div className="text-xs text-orange-600 font-medium flex items-center gap-1">
//                         <Calendar size={11} />
//                         {formatDate(lead.next_call_at)}
//                       </div>
//                     )}
//                     <select
//                       value={lead.status}
//                       onClick={(e) => e.stopPropagation()}
//                       onChange={(e) => handleQuickStatusChange(lead, e.target.value)}
//                       className="text-xs border rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
//                     >
//                       {STATUSES.map(s => (
//                         <option key={s.key} value={s.key}>{s.label}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* ===== ПАНЕЛЬ ЛИДА ===== */}
//         <div className="w-full lg:w-1/3">
//           {!selectedLead ? (
//             <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500 text-sm">
//               Выберите лид слева
//             </div>
//           ) : (
//             <div className="bg-white rounded-2xl shadow-md p-4 space-y-3 sticky top-4">
//               <div className="flex justify-between items-start gap-2">
//                 <div className="min-w-0 flex items-start gap-2">
//                   <User size={18} className="text-gray-500 flex-shrink-0 mt-0.5" />
//                   <div className="min-w-0">
//                     <div className="font-semibold text-gray-800 truncate">
//                       {selectedLead.contact_name || selectedLead.contact_email}
//                     </div>
//                     <div className="text-xs text-gray-500 truncate">
//                       {selectedLead.contact_email}
//                     </div>
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => handleDelete(selectedLead)}
//                   className="text-red-500 hover:text-red-700 p-1 flex-shrink-0"
//                   title="Удалить лид"
//                 >
//                   <Trash2 size={16} />
//                 </button>
//               </div>

//               <div className="space-y-2 text-sm">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-600 mb-1">Статус</label>
//                   <select
//                     value={editForm.status}
//                     onChange={(e) => setEditForm(f => ({ ...f, status: e.target.value }))}
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   >
//                     {STATUSES.map(s => (
//                       <option key={s.key} value={s.key}>{s.label}</option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <PhoneCall size={12} /> Телефон
//                   </label>
//                   <input
//                     type="tel"
//                     value={editForm.phone}
//                     onChange={(e) => setEditForm(f => ({ ...f, phone: e.target.value }))}
//                     placeholder="+7 ..."
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <Calendar size={12} /> Когда позвонить
//                   </label>
//                   <input
//                     type="datetime-local"
//                     value={editForm.next_call_at}
//                     onChange={(e) => setEditForm(f => ({ ...f, next_call_at: e.target.value }))}
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <MessageSquare size={12} /> Комментарий
//                   </label>
//                   <textarea
//                     value={editForm.last_comment}
//                     onChange={(e) => setEditForm(f => ({ ...f, last_comment: e.target.value }))}
//                     rows={3}
//                     placeholder="Что сказали, что договорились..."
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 resize-none"
//                   />
//                 </div>
//               </div>

//               <button
//                 onClick={handleSave}
//                 disabled={savingId === selectedLead.id}
//                 className="w-full px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 text-sm font-medium"
//               >
//                 {savingId === selectedLead.id ? (
//                   "Сохранение..."
//                 ) : (
//                   <span className="inline-flex items-center justify-center gap-2">
//                     <Save size={16} />
//                     Сохранить
//                   </span>
//                 )}
//               </button>

//               {/* ===== Переписка ===== */}
//               {selectedLead.conversation_id && (
//                 <div className="border-t pt-3">
//                   <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center justify-between">
//                     <span className="flex items-center gap-1.5">
//                       <MessageSquare size={12} />
//                       Переписка
//                     </span>
//                     <button
//                       onClick={reloadMessages}
//                       disabled={loadingMessages}
//                       className="text-blue-600 hover:text-blue-800 disabled:opacity-50 p-1"
//                       title="Обновить переписку"
//                     >
//                       <RefreshCw size={14} className={loadingMessages ? "animate-spin" : ""} />
//                     </button>
//                   </div>

//                   {loadingMessages ? (
//                     <div className="text-xs text-gray-400 text-center py-3">Загрузка...</div>
//                   ) : messages.length === 0 ? (
//                     <div className="text-xs text-gray-400 text-center py-3">Нет сообщений</div>
//                   ) : (
//                     <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
//                       {messages.map(m => (
//                         <div
//                           key={m.id}
//                           className={`p-2 rounded-xl text-xs ${
//                             m.sender === "me"
//                               ? "bg-blue-50 ml-4"
//                               : "bg-gray-50 mr-4"
//                           }`}
//                         >
//                           <div className="text-[10px] text-gray-400 mb-0.5">
//                             {m.sender === "me" ? "Вы" : selectedLead.contact_email} · {formatDate(m.created_at)}
//                           </div>
//                           <div className="text-gray-700 whitespace-pre-wrap break-words">
//                             {m.body}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   {/* Форма ответа */}
//                   <LeadReplyForm
//                     conversationId={selectedLead.conversation_id}
//                     contactEmail={selectedLead.contact_email}
//                     defaultSubject={selectedLead.subject}
//                     onSent={reloadMessages}
//                   />
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { useAuth } from "./AuthContext";
// import { getMessages } from "../api/conversationsApi";
// import LeadReplyForm from "./LeadReplyForm";

// import {
//   getLeads,
//   getLeadsStats,
//   getLeadsRevenue,
//   updateLead,
//   deleteLead,
// } from "../api/leadsApi";
// import {
//   Target, Plus, PhoneCall, FileText, FileSignature,
//   CheckCircle2, Ban, Calendar, Building2, Mail, MessageSquare,
//   Trash2, Save, User, RefreshCw, TrendingUp, Wallet, DollarSign,
// } from "lucide-react";



// const STATUSES = [
//   { key: "new",      label: "Новый",     Icon: Plus,           color: "bg-blue-50 border-blue-300",     badge: "bg-blue-100 text-blue-700" },
//   { key: "call",     label: "Позвонить", Icon: PhoneCall,      color: "bg-yellow-50 border-yellow-300", badge: "bg-yellow-100 text-yellow-700" },
//   { key: "invoice",  label: "Счёт",      Icon: FileText,       color: "bg-cyan-50 border-cyan-300",     badge: "bg-cyan-100 text-cyan-700" },
//   { key: "contract", label: "Договор",   Icon: FileSignature,  color: "bg-indigo-50 border-indigo-300", badge: "bg-indigo-100 text-indigo-700" },
//   { key: "deal",     label: "Сделка",    Icon: CheckCircle2,   color: "bg-green-50 border-green-300",   badge: "bg-green-100 text-green-700" },
//   { key: "rejected", label: "Отказ",     Icon: Ban,            color: "bg-red-50 border-red-300",       badge: "bg-red-100 text-red-700" },
// ];

// const STATUS_MAP = Object.fromEntries(STATUSES.map(s => [s.key, s]));

// export default function LeadsPage() {
//   const { user } = useAuth();
//   const [leads, setLeads] = useState([]);
  
//   const [stats, setStats] = useState({});
//   const [revenue, setRevenue] = useState({
//     potential: { total: 0, count: 0 },
//     earned: { total: 0, count: 0 },
//   });
//   const [statusFilter, setStatusFilter] = useState(null); // null = все
//   const [period, setPeriod] = useState("all");
//   const [loading, setLoading] = useState(true);
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [savingId, setSavingId] = useState(null);

  

//   const [editForm, setEditForm] = useState({
//     status: "new",
//     next_call_at: "",
//     last_comment: "",
//     phone: "",
//     amount: "",
//   });

//   const formatMoney = (n) => {
//     if (!n) return "0 ₽";
//     return new Intl.NumberFormat("ru-RU", {
//       style: "currency",
//       currency: "RUB",
//       maximumFractionDigits: 0,
//     }).format(n);
//   };

//   const loadRevenue = async (p = period) => {
//     try {
//       const res = await getLeadsRevenue(p);
//       setRevenue(res.data);
//     } catch (err) {
//       console.error("Ошибка загрузки сумм:", err);
//     }
//   };

//   const loadLeads = async () => {
//     try {
//       setLoading(true);
//       const [leadsRes, statsRes, revenueRes] = await Promise.all([
//         getLeads(),
//         getLeadsStats(),
//         getLeadsRevenue(period),
//       ]);
//       setLeads(leadsRes.data);
//       setStats(statsRes.data);
//       setRevenue(revenueRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка загрузки лидов");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { loadLeads(); }, []);

//   const loadMessagesFor = async (conversationId) => {
//     if (!conversationId) {
//       setMessages([]);
//       return;
//     }
//     setLoadingMessages(true);
//     try {
//       const res = await getMessages(conversationId);
//       setMessages(res.data);
//     } catch (err) {
//       console.error(err);
//       setMessages([]);
//     } finally {
//       setLoadingMessages(false);
//     }
//   };

//   const reloadMessages = () => {
//     if (selectedLead?.conversation_id) {
//       loadMessagesFor(selectedLead.conversation_id);
//     }
//   };

//   const openLead = async (lead) => {
//     setSelectedLead(lead);
//     setEditForm({
//       status: lead.status || "new",
//       next_call_at: lead.next_call_at
//         ? new Date(lead.next_call_at).toISOString().slice(0, 16)
//         : "",
//       last_comment: lead.last_comment || "",
//       phone: lead.phone || "",
//       amount: lead.amount || "",
//     });
//     loadMessagesFor(lead.conversation_id);
//   };

//   const handleSave = async () => {
//     if (!selectedLead) return;
//     setSavingId(selectedLead.id);
//     try {
//       const res = await updateLead(selectedLead.id, {
//         status: editForm.status,
//         next_call_at: editForm.next_call_at || null,
//         last_comment: editForm.last_comment,
//         phone: editForm.phone,
//         amount: Number(editForm.amount) || 0,
//       });
//       setLeads(prev => prev.map(l => l.id === selectedLead.id ? { ...l, ...res.data.lead } : l));
//       setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
//       const [statsRes] = await Promise.all([
//         getLeadsStats(),
//         loadRevenue(),
//       ]);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка сохранения");
//     } finally {
//       setSavingId(null);
//     }
//   };

//   const handleQuickStatusChange = async (lead, newStatus) => {
//     try {
//       const res = await updateLead(lead.id, { status: newStatus });
//       setLeads(prev => prev.map(l => l.id === lead.id ? { ...l, ...res.data.lead } : l));
//       if (selectedLead?.id === lead.id) {
//         setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
//         setEditForm(f => ({ ...f, status: newStatus }));
//       }
//       const [statsRes] = await Promise.all([
//         getLeadsStats(),
//         loadRevenue(),
//       ]);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка смены статуса");
//     }
//   };

//   const handleDelete = async (lead) => {
//     if (!window.confirm(`Удалить лид "${lead.contact_email}"? Переписка останется в общих переписках.`)) return;
//     try {
//       await deleteLead(lead.id);
//       setLeads(prev => prev.filter(l => l.id !== lead.id));
//       if (selectedLead?.id === lead.id) setSelectedLead(null);
//       const [statsRes] = await Promise.all([
//         getLeadsStats(),
//         loadRevenue(),
//       ]);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка удаления");
//     }
//   };

//   const formatDate = (iso) => {
//     if (!iso) return "—";
//     return new Date(iso).toLocaleString("ru-RU", {
//       day: "2-digit", month: "2-digit",
//       hour: "2-digit", minute: "2-digit",
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-4">
//       <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
//         <h1 className="text-xl md:text-2xl font-bold flex items-center gap-2">
//           <Target size={24} className="text-purple-600" />
//           Лиды (CRM)
//         </h1>
//         <div className="text-sm text-gray-500">
//           Всего: {leads.length}
//         </div>
//       </div>

//       {/* Суммы */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 mb-4">
//         <div className="bg-white rounded-2xl shadow-md p-4 border-l-4 border-yellow-500">
//           <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
//             <TrendingUp size={14} className="text-yellow-600" />
//             Потенциальный доход
//           </div>
//           <div className="text-2xl font-bold text-yellow-700">
//             {formatMoney(revenue.potential.total)}
//           </div>
//           <div className="text-xs text-gray-400 mt-1">
//             {revenue.potential.count} лид(ов) в работе
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-4 border-l-4 border-green-500">
//           <div className="flex items-center justify-between mb-1">
//             <div className="flex items-center gap-2 text-xs text-gray-500">
//               <Wallet size={14} className="text-green-600" />
//               Заработано
//             </div>
//             <select
//               value={period}
//               onChange={(e) => {
//                 setPeriod(e.target.value);
//                 loadRevenue(e.target.value);
//               }}
//               className="text-[10px] border rounded-lg px-1.5 py-0.5 bg-white focus:outline-none focus:ring-2 focus:ring-green-400"
//             >
//               <option value="all">За всё время</option>
//               <option value="30d">За 30 дней</option>
//               <option value="7d">За 7 дней</option>
//             </select>
//           </div>
//           <div className="text-2xl font-bold text-green-700">
//             {formatMoney(revenue.earned.total)}
//           </div>
//           <div className="text-xs text-gray-400 mt-1">
//             {revenue.earned.count} сделок
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-md p-4 border-l-4 border-blue-500">
//           <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
//             <DollarSign size={14} className="text-blue-600" />
//             Средний чек
//           </div>
//           <div className="text-2xl font-bold text-blue-700">
//             {formatMoney(
//               revenue.earned.count > 0
//                 ? Math.round(revenue.earned.total / revenue.earned.count)
//                 : 0
//             )}
//           </div>
//           <div className="text-xs text-gray-400 mt-1">
//             по закрытым сделкам
//           </div>
//         </div>
//       </div>

//       {/* Счётчики по статусам */}
//       <div className="grid grid-cols-2 md:grid-cols-6 gap-2 mb-4">
//         {STATUSES.map(s => {
//           const Icon = s.Icon;
//           return (
//             <div key={s.key} className={`rounded-xl p-2 md:p-3 border ${s.color}`}>
//               <div className="flex items-center gap-1.5 text-[10px] md:text-xs font-medium text-gray-600">
//                 <Icon size={14} className="flex-shrink-0" />
//                 <span className="truncate">{s.label}</span>
//               </div>
//               <div className="text-lg md:text-xl font-bold text-gray-800 mt-1">
//                 {stats[s.key] || 0}
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       <div className="flex flex-col lg:flex-row gap-3">
//         {/* ===== СПИСОК ЛИДОВ ===== */}
//         <div className="w-full lg:w-2/3 space-y-2">
//           {loading && (
//             <div className="text-center text-gray-400 py-8">Загрузка...</div>
//           )}

//           {!loading && leads.length === 0 && (
//             <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500">
//               Пока нет лидов. Откройте переписку и нажмите «В лиды».
//             </div>
//           )}

//           {leads
//   .filter(lead => !statusFilter || lead.status === statusFilter)
//   .map(lead => {
//             const StatusIcon = STATUS_MAP[lead.status]?.Icon;
//             return (
//               <div
//                 key={lead.id}
//                 onClick={() => openLead(lead)}
//                 className={`bg-white rounded-2xl shadow-md p-3 md:p-4 cursor-pointer transition border-2 ${
//                   selectedLead?.id === lead.id
//                     ? "border-blue-500"
//                     : "border-transparent hover:border-gray-200"
//                 }`}
//               >
//                 <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2">
//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center gap-2 flex-wrap">
//                       <div className="font-semibold text-gray-800 truncate">
//                         {lead.contact_name || lead.contact_email}
//                       </div>
//                       <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${STATUS_MAP[lead.status]?.badge || "bg-gray-100"}`}>
//                         {StatusIcon && <StatusIcon size={10} />}
//                         {STATUS_MAP[lead.status]?.label || lead.status}
//                       </span>
//                     </div>
//                     {lead.company_name && (
//                       <div className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
//                         <Building2 size={11} className="flex-shrink-0" />
//                         <span className="truncate">{lead.company_name}</span>
//                       </div>
//                     )}
//                     <div className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
//                       <Mail size={11} className="flex-shrink-0" />
//                       <span className="truncate">{lead.contact_email}</span>
//                     </div>
//                     {lead.amount > 0 && (
//                       <div className="text-xs font-semibold text-green-700 truncate mt-0.5 flex items-center gap-1">
//                         <DollarSign size={11} className="flex-shrink-0" />
//                         {formatMoney(lead.amount)}
//                       </div>
//                     )}
//                     {lead.last_message && (
//                       <div className="text-xs text-gray-400 truncate mt-1 flex items-center gap-1">
//                         <MessageSquare size={11} className="flex-shrink-0" />
//                         <span className="truncate">{lead.last_message}</span>
//                       </div>
//                     )}
//                   </div>

//                   <div className="flex flex-col items-end gap-1 flex-shrink-0">
//                     {lead.next_call_at && (
//                       <div className="text-xs text-orange-600 font-medium flex items-center gap-1">
//                         <Calendar size={11} />
//                         {formatDate(lead.next_call_at)}
//                       </div>
//                     )}
//                     <select
//                       value={lead.status}
//                       onClick={(e) => e.stopPropagation()}
//                       onChange={(e) => handleQuickStatusChange(lead, e.target.value)}
//                       className="text-xs border rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
//                     >
//                       {STATUSES.map(s => (
//                         <option key={s.key} value={s.key}>{s.label}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* ===== ПАНЕЛЬ ЛИДА ===== */}
//         <div className="w-full lg:w-1/3">
//           {!selectedLead ? (
//             <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500 text-sm">
//               Выберите лид слева
//             </div>
//           ) : (
//             <div className="bg-white rounded-2xl shadow-md p-4 space-y-3 sticky top-4">
//               <div className="flex justify-between items-start gap-2">
//                 <div className="min-w-0 flex items-start gap-2">
//                   <User size={18} className="text-gray-500 flex-shrink-0 mt-0.5" />
//                   <div className="min-w-0">
//                     <div className="font-semibold text-gray-800 truncate">
//                       {selectedLead.contact_name || selectedLead.contact_email}
//                     </div>
//                     <div className="text-xs text-gray-500 truncate">
//                       {selectedLead.contact_email}
//                     </div>
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => handleDelete(selectedLead)}
//                   className="text-red-500 hover:text-red-700 p-1 flex-shrink-0"
//                   title="Удалить лид"
//                 >
//                   <Trash2 size={16} />
//                 </button>
//               </div>

//               <div className="space-y-2 text-sm">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-600 mb-1">Статус</label>
//                   <select
//                     value={editForm.status}
//                     onChange={(e) => setEditForm(f => ({ ...f, status: e.target.value }))}
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   >
//                     {STATUSES.map(s => (
//                       <option key={s.key} value={s.key}>{s.label}</option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <DollarSign size={12} /> Сумма, ₽
//                   </label>
//                   <input
//                     type="number"
//                     value={editForm.amount}
//                     onChange={(e) => setEditForm(f => ({ ...f, amount: e.target.value }))}
//                     placeholder="0"
//                     min="0"
//                     step="1000"
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <PhoneCall size={12} /> Телефон
//                   </label>
//                   <input
//                     type="tel"
//                     value={editForm.phone}
//                     onChange={(e) => setEditForm(f => ({ ...f, phone: e.target.value }))}
//                     placeholder="+7 ..."
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <Calendar size={12} /> Когда позвонить
//                   </label>
//                   <input
//                     type="datetime-local"
//                     value={editForm.next_call_at}
//                     onChange={(e) => setEditForm(f => ({ ...f, next_call_at: e.target.value }))}
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
//                     <MessageSquare size={12} /> Комментарий
//                   </label>
//                   <textarea
//                     value={editForm.last_comment}
//                     onChange={(e) => setEditForm(f => ({ ...f, last_comment: e.target.value }))}
//                     rows={3}
//                     placeholder="Что сказали, что договорились..."
//                     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 resize-none"
//                   />
//                 </div>
//               </div>

//               <button
//                 onClick={handleSave}
//                 disabled={savingId === selectedLead.id}
//                 className="w-full px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 text-sm font-medium"
//               >
//                 {savingId === selectedLead.id ? (
//                   "Сохранение..."
//                 ) : (
//                   <span className="inline-flex items-center justify-center gap-2">
//                     <Save size={16} />
//                     Сохранить
//                   </span>
//                 )}
//               </button>

//               {selectedLead.conversation_id && (
//                 <div className="border-t pt-3">
//                   <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center justify-between">
//                     <span className="flex items-center gap-1.5">
//                       <MessageSquare size={12} />
//                       Переписка
//                     </span>
//                     <button
//                       onClick={reloadMessages}
//                       disabled={loadingMessages}
//                       className="text-blue-600 hover:text-blue-800 disabled:opacity-50 p-1"
//                       title="Обновить переписку"
//                     >
//                       <RefreshCw size={14} className={loadingMessages ? "animate-spin" : ""} />
//                     </button>
//                   </div>

//                   {loadingMessages ? (
//                     <div className="text-xs text-gray-400 text-center py-3">Загрузка...</div>
//                   ) : messages.length === 0 ? (
//                     <div className="text-xs text-gray-400 text-center py-3">Нет сообщений</div>
//                   ) : (
//                     <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
//                       {messages.map(m => (
//                         <div
//                           key={m.id}
//                           className={`p-2 rounded-xl text-xs ${
//                             m.sender === "me"
//                               ? "bg-blue-50 ml-4"
//                               : "bg-gray-50 mr-4"
//                           }`}
//                         >
//                           <div className="text-[10px] text-gray-400 mb-0.5">
//                             {m.sender === "me" ? "Вы" : selectedLead.contact_email} · {formatDate(m.created_at)}
//                           </div>
//                           <div className="text-gray-700 whitespace-pre-wrap break-words">
//                             {m.body}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   <LeadReplyForm
//                     conversationId={selectedLead.conversation_id}
//                     contactEmail={selectedLead.contact_email}
//                     defaultSubject={selectedLead.subject}
//                     onSent={reloadMessages}
//                   />
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


//Последний рабочий вариант перед обноылением с паутиной
import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { getMessages } from "../api/conversationsApi";
import LeadReplyForm from "./LeadReplyForm";

import {
  getLeads,
  getLeadsStats,
  getLeadsRevenue,
  updateLead,
  deleteLead,
} from "../api/leadsApi";
import {
  Target, Plus, PhoneCall, FileText, FileSignature,
  CheckCircle2, Ban, Calendar, Building2, Mail, MessageSquare,
  Trash2, Save, User, RefreshCw, TrendingUp, Wallet, DollarSign,
} from "lucide-react";

const STATUSES = [
  { key: "new",      label: "Новый",     Icon: Plus,           color: "bg-blue-50 border-blue-300",     badge: "bg-blue-100 text-blue-700" },
  { key: "call",     label: "Позвонить", Icon: PhoneCall,      color: "bg-yellow-50 border-yellow-300", badge: "bg-yellow-100 text-yellow-700" },
  { key: "invoice",  label: "Счёт",      Icon: FileText,       color: "bg-cyan-50 border-cyan-300",     badge: "bg-cyan-100 text-cyan-700" },
  { key: "contract", label: "Договор",   Icon: FileSignature,  color: "bg-indigo-50 border-indigo-300", badge: "bg-indigo-100 text-indigo-700" },
  { key: "deal",     label: "Сделка",    Icon: CheckCircle2,   color: "bg-green-50 border-green-300",   badge: "bg-green-100 text-green-700" },
  { key: "rejected", label: "Отказ",     Icon: Ban,            color: "bg-red-50 border-red-300",       badge: "bg-red-100 text-red-700" },
];

const STATUS_MAP = Object.fromEntries(STATUSES.map(s => [s.key, s]));

export default function LeadsPage() {
  const { user } = useAuth();
  const [leads, setLeads] = useState([]);
  const [stats, setStats] = useState({});
  const [revenue, setRevenue] = useState({
    potential: { total: 0, count: 0 },
    earned: { total: 0, count: 0 },
  });
  const [statusFilter, setStatusFilter] = useState(null); // null = все
  const [period, setPeriod] = useState("all");
  const [loading, setLoading] = useState(true);
  const [selectedLead, setSelectedLead] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [savingId, setSavingId] = useState(null);

  const [editForm, setEditForm] = useState({
    status: "new",
    next_call_at: "",
    last_comment: "",
    phone: "",
    amount: "",
  });

  const formatMoney = (n) => {
    if (!n) return "0 ₽";
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: "RUB",
      maximumFractionDigits: 0,
    }).format(n);
  };

  const loadRevenue = async (p = period) => {
    try {
      const res = await getLeadsRevenue(p);
      setRevenue(res.data);
    } catch (err) {
      console.error("Ошибка загрузки сумм:", err);
    }
  };

  const loadLeads = async () => {
    try {
      setLoading(true);
      const [leadsRes, statsRes, revenueRes] = await Promise.all([
        getLeads(),
        getLeadsStats(),
        getLeadsRevenue(period),
      ]);
      setLeads(leadsRes.data);
      setStats(statsRes.data);
      setRevenue(revenueRes.data);
    } catch (err) {
      console.error(err);
      alert("Ошибка загрузки лидов");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadLeads(); }, []);

  // Сброс выбранного лида, если он не попадает под фильтр
  useEffect(() => {
    if (!statusFilter || !selectedLead) return;
    if (selectedLead.status !== statusFilter) {
      setSelectedLead(null);
      setMessages([]);
    }
  }, [statusFilter]);

  const loadMessagesFor = async (conversationId) => {
    if (!conversationId) {
      setMessages([]);
      return;
    }
    setLoadingMessages(true);
    try {
      const res = await getMessages(conversationId);
      setMessages(res.data);
    } catch (err) {
      console.error(err);
      setMessages([]);
    } finally {
      setLoadingMessages(false);
    }
  };

  const reloadMessages = () => {
    if (selectedLead?.conversation_id) {
      loadMessagesFor(selectedLead.conversation_id);
    }
  };

  const openLead = async (lead) => {
    setSelectedLead(lead);
    setEditForm({
      status: lead.status || "new",
      next_call_at: lead.next_call_at
        ? new Date(lead.next_call_at).toISOString().slice(0, 16)
        : "",
      last_comment: lead.last_comment || "",
      phone: lead.phone || "",
      amount: lead.amount || "",
    });
    loadMessagesFor(lead.conversation_id);
  };

  const handleSave = async () => {
    if (!selectedLead) return;
    setSavingId(selectedLead.id);
    try {
      const res = await updateLead(selectedLead.id, {
        status: editForm.status,
        next_call_at: editForm.next_call_at || null,
        last_comment: editForm.last_comment,
        phone: editForm.phone,
        amount: Number(editForm.amount) || 0,
      });
      setLeads(prev => prev.map(l => l.id === selectedLead.id ? { ...l, ...res.data.lead } : l));
      setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
      const [statsRes] = await Promise.all([
        getLeadsStats(),
        loadRevenue(),
      ]);
      setStats(statsRes.data);
    } catch (err) {
      console.error(err);
      alert("Ошибка сохранения");
    } finally {
      setSavingId(null);
    }
  };

  const handleQuickStatusChange = async (lead, newStatus) => {
    try {
      const res = await updateLead(lead.id, { status: newStatus });
      setLeads(prev => prev.map(l => l.id === lead.id ? { ...l, ...res.data.lead } : l));
      if (selectedLead?.id === lead.id) {
        setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
        setEditForm(f => ({ ...f, status: newStatus }));
      }
      const [statsRes] = await Promise.all([
        getLeadsStats(),
        loadRevenue(),
      ]);
      setStats(statsRes.data);
    } catch (err) {
      console.error(err);
      alert("Ошибка смены статуса");
    }
  };

  const handleDelete = async (lead) => {
    if (!window.confirm(`Удалить лид "${lead.contact_email}"? Переписка останется в общих переписках.`)) return;
    try {
      await deleteLead(lead.id);
      setLeads(prev => prev.filter(l => l.id !== lead.id));
      if (selectedLead?.id === lead.id) setSelectedLead(null);
      const [statsRes] = await Promise.all([
        getLeadsStats(),
        loadRevenue(),
      ]);
      setStats(statsRes.data);
    } catch (err) {
      console.error(err);
      alert("Ошибка удаления");
    }
  };

  const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleString("ru-RU", {
      day: "2-digit", month: "2-digit",
      hour: "2-digit", minute: "2-digit",
    });
  };

  // Отфильтрованный список лидов
  const filteredLeads = leads.filter(
    lead => !statusFilter || lead.status === statusFilter
  );

  return (
    <div className="min-h-screen bg-gray-50 p-3 md:p-4">
      {/* Заголовок */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl md:text-2xl font-bold flex items-center gap-2">
          <Target size={24} className="text-purple-600" />
          Лиды (CRM)
        </h1>
        <div className="text-sm text-gray-500 flex items-center gap-2">
          {statusFilter ? (
            <>
              <span>
                Показано: {filteredLeads.length} из {leads.length}
              </span>
              <button
                onClick={() => setStatusFilter(null)}
                className="text-blue-600 hover:text-blue-800 text-xs underline"
              >
                сбросить
              </button>
            </>
          ) : (
            <span>Всего: {leads.length}</span>
          )}
        </div>
      </div>

      {/* Суммы */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 mb-4">
        <div className="bg-white rounded-2xl shadow-md p-4 border-l-4 border-yellow-500">
          <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
            <TrendingUp size={14} className="text-yellow-600" />
            Потенциальный доход
          </div>
          <div className="text-2xl font-bold text-yellow-700">
            {formatMoney(revenue.potential.total)}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {revenue.potential.count} лид(ов) в работе
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-4 border-l-4 border-green-500">
          <div className="flex items-center justify-between mb-1">
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Wallet size={14} className="text-green-600" />
              Заработано
            </div>
            <select
              value={period}
              onChange={(e) => {
                setPeriod(e.target.value);
                loadRevenue(e.target.value);
              }}
              className="text-[10px] border rounded-lg px-1.5 py-0.5 bg-white focus:outline-none focus:ring-2 focus:ring-green-400"
            >
              <option value="all">За всё время</option>
              <option value="30d">За 30 дней</option>
              <option value="7d">За 7 дней</option>
            </select>
          </div>
          <div className="text-2xl font-bold text-green-700">
            {formatMoney(revenue.earned.total)}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {revenue.earned.count} сделок
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-4 border-l-4 border-blue-500">
          <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
            <DollarSign size={14} className="text-blue-600" />
            Средний чек
          </div>
          <div className="text-2xl font-bold text-blue-700">
            {formatMoney(
              revenue.earned.count > 0
                ? Math.round(revenue.earned.total / revenue.earned.count)
                : 0
            )}
          </div>
          <div className="text-xs text-gray-400 mt-1">
            по закрытым сделкам
          </div>
        </div>
      </div>

      {/* Счётчики по статусам — кликабельные */}
      <div className="grid grid-cols-2 md:grid-cols-6 gap-2 mb-4">
        {STATUSES.map(s => {
          const Icon = s.Icon;
          const isActive = statusFilter === s.key;
          const count = stats[s.key] || 0;

          return (
            <button
              key={s.key}
              onClick={() => setStatusFilter(prev => prev === s.key ? null : s.key)}
              disabled={count === 0 && !isActive}
              className={`rounded-xl p-2 md:p-3 border text-left transition ${s.color} ${
                isActive
                  ? "ring-2 ring-offset-1 ring-blue-500 shadow-md"
                  : "hover:shadow-md hover:scale-[1.02]"
              } ${
                count === 0 && !isActive
                  ? "opacity-50 cursor-not-allowed"
                  : "cursor-pointer"
              }`}
              title={
                count === 0
                  ? "Нет лидов с этим статусом"
                  : isActive
                    ? "Кликните, чтобы сбросить фильтр"
                    : `Показать только «${s.label}»`
              }
            >
              <div className="flex items-center gap-1.5 text-[10px] md:text-xs font-medium text-gray-600">
                <Icon size={14} className="flex-shrink-0" />
                <span className="truncate">{s.label}</span>
              </div>
              <div className="text-lg md:text-xl font-bold text-gray-800 mt-1">
                {count}
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex flex-col lg:flex-row gap-3">
        {/* ===== СПИСОК ЛИДОВ ===== */}
        <div className="w-full lg:w-2/3 space-y-2">
          {loading && (
            <div className="text-center text-gray-400 py-8">Загрузка...</div>
          )}

          {!loading && leads.length === 0 && (
            <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500">
              Пока нет лидов. Откройте переписку и нажмите «В лиды».
            </div>
          )}

          {!loading && leads.length > 0 && filteredLeads.length === 0 && (
            <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500">
              Нет лидов со статусом «{STATUS_MAP[statusFilter]?.label}».
              <button
                onClick={() => setStatusFilter(null)}
                className="ml-2 text-blue-600 hover:text-blue-800 underline"
              >
                Показать все
              </button>
            </div>
          )}

          {filteredLeads.map(lead => {
            const StatusIcon = STATUS_MAP[lead.status]?.Icon;
            return (
              <div
                key={lead.id}
                onClick={() => openLead(lead)}
                className={`bg-white rounded-2xl shadow-md p-3 md:p-4 cursor-pointer transition border-2 ${
                  selectedLead?.id === lead.id
                    ? "border-blue-500"
                    : "border-transparent hover:border-gray-200"
                }`}
              >
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <div className="font-semibold text-gray-800 truncate">
                        {lead.contact_name || lead.contact_email}
                      </div>
                      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${STATUS_MAP[lead.status]?.badge || "bg-gray-100"}`}>
                        {StatusIcon && <StatusIcon size={10} />}
                        {STATUS_MAP[lead.status]?.label || lead.status}
                      </span>
                    </div>
                    {lead.company_name && (
                      <div className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
                        <Building2 size={11} className="flex-shrink-0" />
                        <span className="truncate">{lead.company_name}</span>
                      </div>
                    )}
                    <div className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
                      <Mail size={11} className="flex-shrink-0" />
                      <span className="truncate">{lead.contact_email}</span>
                    </div>
                    {lead.amount > 0 && (
                      <div className="text-xs font-semibold text-green-700 truncate mt-0.5 flex items-center gap-1">
                        <DollarSign size={11} className="flex-shrink-0" />
                        {formatMoney(lead.amount)}
                      </div>
                    )}
                    {lead.last_message && (
                      <div className="text-xs text-gray-400 truncate mt-1 flex items-center gap-1">
                        <MessageSquare size={11} className="flex-shrink-0" />
                        <span className="truncate">{lead.last_message}</span>
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col items-end gap-1 flex-shrink-0">
                    {lead.next_call_at && (
                      <div className="text-xs text-orange-600 font-medium flex items-center gap-1">
                        <Calendar size={11} />
                        {formatDate(lead.next_call_at)}
                      </div>
                    )}
                    <select
                      value={lead.status}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => handleQuickStatusChange(lead, e.target.value)}
                      className="text-xs border rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                    >
                      {STATUSES.map(s => (
                        <option key={s.key} value={s.key}>{s.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* ===== ПАНЕЛЬ ЛИДА ===== */}
        <div className="w-full lg:w-1/3">
          {!selectedLead ? (
            <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500 text-sm">
              Выберите лид слева
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-md p-4 space-y-3 sticky top-4">
              <div className="flex justify-between items-start gap-2">
                <div className="min-w-0 flex items-start gap-2">
                  <User size={18} className="text-gray-500 flex-shrink-0 mt-0.5" />
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-800 truncate">
                      {selectedLead.contact_name || selectedLead.contact_email}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {selectedLead.contact_email}
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => handleDelete(selectedLead)}
                  className="text-red-500 hover:text-red-700 p-1 flex-shrink-0"
                  title="Удалить лид"
                >
                  <Trash2 size={16} />
                </button>
              </div>

              <div className="space-y-2 text-sm">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Статус</label>
                  <select
                    value={editForm.status}
                    onChange={(e) => setEditForm(f => ({ ...f, status: e.target.value }))}
                    className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                  >
                    {STATUSES.map(s => (
                      <option key={s.key} value={s.key}>{s.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
                    <DollarSign size={12} /> Сумма, ₽
                  </label>
                  <input
                    type="number"
                    value={editForm.amount}
                    onChange={(e) => setEditForm(f => ({ ...f, amount: e.target.value }))}
                    placeholder="0"
                    min="0"
                    step="1000"
                    className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div>
                  <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
                    <PhoneCall size={12} /> Телефон
                  </label>
                  <input
                    type="tel"
                    value={editForm.phone}
                    onChange={(e) => setEditForm(f => ({ ...f, phone: e.target.value }))}
                    placeholder="+7 ..."
                    className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div>
                  <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
                    <Calendar size={12} /> Когда позвонить
                  </label>
                  <input
                    type="datetime-local"
                    value={editForm.next_call_at}
                    onChange={(e) => setEditForm(f => ({ ...f, next_call_at: e.target.value }))}
                    className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <div>
                  <label className="text-xs font-medium text-gray-600 mb-1 flex items-center gap-1">
                    <MessageSquare size={12} /> Комментарий
                  </label>
                  <textarea
                    value={editForm.last_comment}
                    onChange={(e) => setEditForm(f => ({ ...f, last_comment: e.target.value }))}
                    rows={3}
                    placeholder="Что сказали, что договорились..."
                    className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 resize-none"
                  />
                </div>
              </div>

              <button
                onClick={handleSave}
                disabled={savingId === selectedLead.id}
                className="w-full px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 text-sm font-medium"
              >
                {savingId === selectedLead.id ? (
                  "Сохранение..."
                ) : (
                  <span className="inline-flex items-center justify-center gap-2">
                    <Save size={16} />
                    Сохранить
                  </span>
                )}
              </button>

              {selectedLead.conversation_id && (
                <div className="border-t pt-3">
                  <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center justify-between">
                    <span className="flex items-center gap-1.5">
                      <MessageSquare size={12} />
                      Переписка
                    </span>
                    <button
                      onClick={reloadMessages}
                      disabled={loadingMessages}
                      className="text-blue-600 hover:text-blue-800 disabled:opacity-50 p-1"
                      title="Обновить переписку"
                    >
                      <RefreshCw size={14} className={loadingMessages ? "animate-spin" : ""} />
                    </button>
                  </div>

                  {loadingMessages ? (
                    <div className="text-xs text-gray-400 text-center py-3">Загрузка...</div>
                  ) : messages.length === 0 ? (
                    <div className="text-xs text-gray-400 text-center py-3">Нет сообщений</div>
                  ) : (
                    <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
                      {messages.map(m => (
                        <div
                          key={m.id}
                          className={`p-2 rounded-xl text-xs ${
                            m.sender === "me"
                              ? "bg-blue-50 ml-4"
                              : "bg-gray-50 mr-4"
                          }`}
                        >
                          <div className="text-[10px] text-gray-400 mb-0.5">
                            {m.sender === "me" ? "Вы" : selectedLead.contact_email} · {formatDate(m.created_at)}
                          </div>
                          <div className="text-gray-700 whitespace-pre-wrap break-words">
                            {m.body}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <LeadReplyForm
                    conversationId={selectedLead.conversation_id}
                    contactEmail={selectedLead.contact_email}
                    defaultSubject={selectedLead.subject}
                    onSent={reloadMessages}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


// красивый дизайн с ксс
// import React, { useState, useEffect, useMemo } from "react";
// import { useAuth } from "./AuthContext";
// import { getMessages } from "../api/conversationsApi";
// import LeadReplyForm from "./LeadReplyForm";
// import {
//   getLeads,
//   getLeadsStats,
//   getLeadsRevenue,
//   updateLead,
//   deleteLead,
// } from "../api/leadsApi";
// import {
//   Target, Plus, PhoneCall, FileText, FileSignature,
//   CheckCircle2, Ban, Calendar, Building2, Mail, MessageSquare,
//   Trash2, Save, User, RefreshCw, TrendingUp, Wallet, DollarSign,
//   Search, SlidersHorizontal, MoreHorizontal, Send, Link2, Eye,
//   ArrowUpRight, X, ChevronDown, Users, Sparkles, MapPin,
// } from "lucide-react";
// import "./LeadsPage.css";

// const STATUSES = [
//   { key: "new", label: "Новый", Icon: Plus, tone: "blue" },
//   { key: "call", label: "Позвонить", Icon: PhoneCall, tone: "amber" },
//   { key: "invoice", label: "Счёт", Icon: FileText, tone: "cyan" },
//   { key: "contract", label: "Договор", Icon: FileSignature, tone: "indigo" },
//   { key: "deal", label: "Сделка", Icon: CheckCircle2, tone: "green" },
//   { key: "rejected", label: "Отказ", Icon: Ban, tone: "red" },
// ];

// const STATUS_MAP = Object.fromEntries(STATUSES.map(s => [s.key, s]));

// const NODE_LAYOUT = [
//   { x: 18, y: 24, size: "large" },
//   { x: 52, y: 17, size: "medium" },
//   { x: 73, y: 39, size: "medium" },
//   { x: 36, y: 52, size: "medium" },
//   { x: 66, y: 70, size: "large" },
//   { x: 20, y: 76, size: "medium" },
//   { x: 49, y: 82, size: "small" },
//   { x: 84, y: 75, size: "small" },
// ];

// function initials(lead) {
//   const value = lead?.contact_name || lead?.company_name || lead?.contact_email || "?";
//   return value
//     .split(/[\s@._-]+/)
//     .filter(Boolean)
//     .slice(0, 2)
//     .map(x => x[0])
//     .join("")
//     .toUpperCase();
// }

// function avatarTone(index) {
//   return ["lavender", "blue", "mint", "peach", "sky", "violet"][index % 6];
// }

// export default function LeadsPage() {
//   const { user } = useAuth();

//   const [leads, setLeads] = useState([]);
//   const [stats, setStats] = useState({});
//   const [revenue, setRevenue] = useState({
//     potential: { total: 0, count: 0 },
//     earned: { total: 0, count: 0 },
//   });

//   const [statusFilter, setStatusFilter] = useState(null);
//   const [period, setPeriod] = useState("all");
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [savingId, setSavingId] = useState(null);
//   const [showDetails, setShowDetails] = useState(true);

//   const [editForm, setEditForm] = useState({
//     status: "new",
//     next_call_at: "",
//     last_comment: "",
//     phone: "",
//     amount: "",
//   });

//   const formatMoney = (n) => {
//     if (!n) return "0 ₽";
//     return new Intl.NumberFormat("ru-RU", {
//       style: "currency",
//       currency: "RUB",
//       maximumFractionDigits: 0,
//     }).format(n);
//   };

//   const loadRevenue = async (p = period) => {
//     try {
//       const res = await getLeadsRevenue(p);
//       setRevenue(res.data);
//     } catch (err) {
//       console.error("Ошибка загрузки сумм:", err);
//     }
//   };

//   const loadLeads = async () => {
//     try {
//       setLoading(true);
//       const [leadsRes, statsRes, revenueRes] = await Promise.all([
//         getLeads(),
//         getLeadsStats(),
//         getLeadsRevenue(period),
//       ]);
//       setLeads(leadsRes.data);
//       setStats(statsRes.data);
//       setRevenue(revenueRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка загрузки лидов");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadLeads();
//   }, []);

//   useEffect(() => {
//     if (!statusFilter || !selectedLead) return;
//     if (selectedLead.status !== statusFilter) {
//       setSelectedLead(null);
//       setMessages([]);
//     }
//   }, [statusFilter]);

//   const loadMessagesFor = async (conversationId) => {
//     if (!conversationId) {
//       setMessages([]);
//       return;
//     }

//     setLoadingMessages(true);
//     try {
//       const res = await getMessages(conversationId);
//       setMessages(res.data);
//     } catch (err) {
//       console.error(err);
//       setMessages([]);
//     } finally {
//       setLoadingMessages(false);
//     }
//   };

//   const reloadMessages = () => {
//     if (selectedLead?.conversation_id) {
//       loadMessagesFor(selectedLead.conversation_id);
//     }
//   };

//   const openLead = async (lead) => {
//     setSelectedLead(lead);
//     setShowDetails(true);
//     setEditForm({
//       status: lead.status || "new",
//       next_call_at: lead.next_call_at
//         ? new Date(lead.next_call_at).toISOString().slice(0, 16)
//         : "",
//       last_comment: lead.last_comment || "",
//       phone: lead.phone || "",
//       amount: lead.amount || "",
//     });
//     loadMessagesFor(lead.conversation_id);
//   };

//   const handleSave = async () => {
//     if (!selectedLead) return;

//     setSavingId(selectedLead.id);
//     try {
//       const res = await updateLead(selectedLead.id, {
//         status: editForm.status,
//         next_call_at: editForm.next_call_at || null,
//         last_comment: editForm.last_comment,
//         phone: editForm.phone,
//         amount: Number(editForm.amount) || 0,
//       });

//       setLeads(prev =>
//         prev.map(l => l.id === selectedLead.id ? { ...l, ...res.data.lead } : l)
//       );
//       setSelectedLead(prev => ({ ...prev, ...res.data.lead }));

//       const [statsRes] = await Promise.all([
//         getLeadsStats(),
//         loadRevenue(),
//       ]);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка сохранения");
//     } finally {
//       setSavingId(null);
//     }
//   };

//   const handleQuickStatusChange = async (lead, newStatus) => {
//     try {
//       const res = await updateLead(lead.id, { status: newStatus });

//       setLeads(prev =>
//         prev.map(l => l.id === lead.id ? { ...l, ...res.data.lead } : l)
//       );

//       if (selectedLead?.id === lead.id) {
//         setSelectedLead(prev => ({ ...prev, ...res.data.lead }));
//         setEditForm(f => ({ ...f, status: newStatus }));
//       }

//       const [statsRes] = await Promise.all([
//         getLeadsStats(),
//         loadRevenue(),
//       ]);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка смены статуса");
//     }
//   };

//   const handleDelete = async (lead) => {
//     if (!window.confirm(`Удалить лид "${lead.contact_email}"? Переписка останется в общих переписках.`)) return;

//     try {
//       await deleteLead(lead.id);
//       setLeads(prev => prev.filter(l => l.id !== lead.id));
//       if (selectedLead?.id === lead.id) setSelectedLead(null);

//       const [statsRes] = await Promise.all([
//         getLeadsStats(),
//         loadRevenue(),
//       ]);
//       setStats(statsRes.data);
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка удаления");
//     }
//   };

//   const formatDate = (iso) => {
//     if (!iso) return "—";
//     return new Date(iso).toLocaleString("ru-RU", {
//       day: "2-digit",
//       month: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const filteredLeads = useMemo(() => {
//     const q = search.trim().toLowerCase();

//     return leads.filter(lead => {
//       const matchesStatus = !statusFilter || lead.status === statusFilter;

//       const haystack = [
//         lead.contact_name,
//         lead.contact_email,
//         lead.company_name,
//         lead.last_message,
//         lead.phone,
//       ].filter(Boolean).join(" ").toLowerCase();

//       return matchesStatus && (!q || haystack.includes(q));
//     });
//   }, [leads, statusFilter, search]);

//   const visibleNodes = filteredLeads.slice(0, 8);
//   const completedCount = stats.deal || 0;
//   const totalLeads = leads.length;

//   return (
//     <div className="mailora-crm">
//       <div className="crm-orb crm-orb-a" />
//       <div className="crm-orb crm-orb-b" />
//       <div className="crm-orb crm-orb-c" />

//       {/* SIDEBAR */}
//       <aside className="crm-sidebar">
//         <div className="crm-brand">
//           <div className="crm-brand-mark">
//             <span />
//             <span />
//             <span />
//           </div>
//           <div>
//             <div className="crm-brand-name">Mailora</div>
//             <div className="crm-brand-subtitle">Email Outreach Platform</div>
//           </div>
//         </div>

//         <nav className="crm-nav">
//           {[
//             [Target, "Дашборд"],
//             [Send, "Кампании"],
//             [Users, "Лиды"],
//             [MessageSquare, "Помощь"],
//             [Mail, "Почты"],
//             [Send, "Рассылки"],
//             [MessageSquare, "Переписки"],
//             [FileText, "Шаблоны"],
//             [Building2, "Каталог"],
//             [Wallet, "Тарифы"],
//             [SlidersHorizontal, "Настройки"],
//           ].map(([Icon, label]) => (
//             <button
//               key={label}
//               className={`crm-nav-item ${label === "Лиды" ? "active" : ""}`}
//             >
//               <Icon size={18} strokeWidth={1.8} />
//               <span>{label}</span>
//               {label === "Лиды" && <span className="crm-nav-count">{totalLeads || "1.2K"}</span>}
//             </button>
//           ))}
//         </nav>

//         <div className="crm-sidebar-bottom">
//           <div className="crm-free-card">
//             <Sparkles size={22} />
//             <div>
//               <strong>Осталось 7 дней</strong>
//               <span>бесплатного доступа</span>
//             </div>
//             <button>Перейти к тарифу <ArrowUpRight size={14} /></button>
//           </div>

//           <div className="crm-user">
//             <div className="crm-user-avatar">
//               {(user?.name || "Р").slice(0, 1).toUpperCase()}
//             </div>
//             <div>
//               <strong>{user?.name || "Руслан"}</strong>
//               <span>Pro · 4900 ₽/мес</span>
//             </div>
//             <ChevronDown size={16} />
//           </div>
//         </div>
//       </aside>

//       {/* MAIN */}
//       <main className="crm-main">
//         <header className="crm-topbar">
//           <div className="crm-search">
//             <Search size={18} />
//             <input
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//               placeholder="Поиск по лидам, компаниям, контактам..."
//             />
//             <kbd>⌘K</kbd>
//           </div>

//           <div className="crm-top-actions">
//             <button className="crm-icon-button"><RefreshCw size={18} /></button>
//             <button className="crm-notification">
//               <span />
//               <Mail size={18} />
//             </button>
//             <div className="crm-account">
//               <div className="crm-account-avatar">{(user?.name || "Р").slice(0, 1)}</div>
//               <div>
//                 <strong>Mailora</strong>
//                 <span>Ваша команда</span>
//               </div>
//               <ChevronDown size={15} />
//             </div>
//           </div>
//         </header>

//         <section className="crm-heading">
//           <div>
//             <div className="crm-eyebrow"><span /> CRM workspace</div>
//             <h1>Лиды</h1>
//             <p>Твои потенциальные клиенты уже здесь.<br />Остается только связаться.</p>
//           </div>

//           <div className="crm-heading-actions">
//             <button className="crm-filter-button">
//               <Calendar size={16} />
//               30.09.2026 — 21.10.2026
//               <ChevronDown size={15} />
//             </button>
//             <button className="crm-primary-button">
//               <Plus size={18} />
//               Новый лид
//             </button>
//           </div>
//         </section>

//         {/* METRICS */}
//         <section className="crm-metrics">
//           <Metric icon={Users} label="Всего лидов" value={totalLeads || 1124} change="12%" tone="blue" />
//           <Metric icon={PhoneCall} label="В работе" value={stats.call || 486} change="8%" tone="amber" />
//           <Metric icon={Mail} label="Контакты" value={stats.invoice || 231} change="15%" tone="violet" />
//           <Metric icon={CheckCircle2} label="Сделки" value={completedCount || 95} change="22%" tone="green" />
//           <div className="crm-goal-card">
//             <div className="crm-goal-title">
//               <span>Цель на месяц</span>
//               <MoreHorizontal size={17} />
//             </div>
//             <strong>200+ лидов</strong>
//             <div className="crm-progress"><span style={{ width: "56%" }} /></div>
//             <small>56%</small>
//           </div>
//         </section>

//         {/* FILTERS */}
//         <div className="crm-toolbar">
//           <div className="crm-pills">
//             {[
//               [null, "Все"],
//               ["new", "Новые"],
//               ["call", "В работе"],
//               ["invoice", "Контакты"],
//               ["deal", "Сделки"],
//             ].map(([key, label]) => (
//               <button
//                 key={label}
//                 onClick={() => setStatusFilter(key)}
//                 className={statusFilter === key ? "active" : ""}
//               >
//                 {label}
//               </button>
//             ))}
//           </div>

//           <div className="crm-toolbar-right">
//             <button className="crm-small-button"><SlidersHorizontal size={15} /> Фильтры</button>
//             <button className="crm-small-button">По дате создания <ChevronDown size={14} /></button>
//             <button className="crm-view-button active"><Users size={16} /></button>
//             <button className="crm-view-button"><Target size={16} /></button>
//           </div>
//         </div>

//         {/* WORKSPACE */}
//         <section className={`crm-workspace ${showDetails && selectedLead ? "with-details" : ""}`}>
//           <div className="crm-network">
//             <div className="crm-network-head">
//               <div>
//                 <span className="crm-network-label">ПРОСТРАНСТВО ЛИДОВ</span>
//                 <strong>{filteredLeads.length || 0} потенциальных клиентов</strong>
//               </div>
//               <button onClick={() => setShowDetails(false)} className="crm-canvas-button">
//                 <Target size={15} /> Сеть
//               </button>
//             </div>

//             <svg className="crm-connections" viewBox="0 0 100 100" preserveAspectRatio="none">
//               <path d="M18 30 C32 26, 40 18, 52 22" />
//               <path d="M52 22 C61 26, 67 31, 73 44" />
//               <path d="M18 30 C22 42, 30 48, 36 57" />
//               <path d="M36 57 C48 59, 58 67, 66 73" />
//               <path d="M20 80 C26 68, 30 62, 36 57" />
//               <path d="M66 73 C73 73, 78 76, 84 78" />
//               <path d="M52 22 C47 37, 41 46, 36 57" />
//             </svg>

//             <div className="crm-network-glow glow-one" />
//             <div className="crm-network-glow glow-two" />
//             <div className="crm-network-glow glow-three" />

//             {loading && (
//               <div className="crm-empty-state">Загрузка лидов…</div>
//             )}

//             {!loading && visibleNodes.length === 0 && (
//               <div className="crm-empty-state">
//                 <Users size={28} />
//                 <strong>Здесь пока тихо</strong>
//                 <span>Добавьте первого лида или измените фильтр.</span>
//               </div>
//             )}

//             {!loading && visibleNodes.map((lead, index) => {
//               const position = NODE_LAYOUT[index % NODE_LAYOUT.length];
//               const status = STATUS_MAP[lead.status];
//               const isSelected = selectedLead?.id === lead.id;

//               return (
//                 <button
//                   key={lead.id}
//                   className={`lead-node ${position.size} ${isSelected ? "selected" : ""}`}
//                   style={{ left: `${position.x}%`, top: `${position.y}%` }}
//                   onClick={() => openLead(lead)}
//                 >
//                   <div className={`lead-avatar ${avatarTone(index)}`}>{initials(lead)}</div>
//                   <div className="lead-node-copy">
//                     <strong>{lead.contact_name || lead.contact_email}</strong>
//                     <span>{lead.contact_email}</span>
//                     <div className="lead-node-meta">
//                       {lead.company_name && <em>{lead.company_name}</em>}
//                       <b className={`status-dot ${status?.tone || "blue"}`}>
//                         {status?.label || lead.status}
//                       </b>
//                     </div>
//                   </div>
//                   <div className="lead-node-money">
//                     {lead.amount > 0 ? formatMoney(lead.amount) : "Новый"}
//                   </div>
//                   <span className="lead-node-action"><Mail size={14} /></span>
//                 </button>
//               );
//             })}

//             <div className="crm-floating-note note-a">
//               <Eye size={14} />
//               <span><b>38</b> новых действий</span>
//             </div>

//             <div className="crm-floating-note note-b">
//               <Link2 size={14} />
//               <span>связь установлена</span>
//             </div>
//           </div>

//           {/* DETAIL PANEL */}
//           {showDetails && selectedLead && (
//             <aside className="crm-detail-panel">
//               <div className="crm-detail-top">
//                 <button onClick={() => setShowDetails(false)} className="crm-back">
//                   <ChevronDown size={16} /> К лидам
//                 </button>
//                 <button onClick={() => handleDelete(selectedLead)} className="crm-danger-icon">
//                   <Trash2 size={16} />
//                 </button>
//               </div>

//               <div className="crm-profile">
//                 <div className={`crm-profile-avatar ${avatarTone(0)}`}>
//                   {initials(selectedLead)}
//                 </div>
//                 <div className="crm-profile-name">
//                   <h2>{selectedLead.contact_name || selectedLead.contact_email}</h2>
//                   <a href={`mailto:${selectedLead.contact_email}`}>{selectedLead.contact_email}</a>
//                   <span className={`profile-status ${STATUS_MAP[selectedLead.status]?.tone || "blue"}`}>
//                     {STATUS_MAP[selectedLead.status]?.label || selectedLead.status}
//                   </span>
//                 </div>
//               </div>

//               <div className="crm-tags">
//                 <span><Building2 size={12} /> {selectedLead.company_name || "Компания"}</span>
//                 <span>B2B</span>
//                 <span>Москва</span>
//               </div>

//               <p className="crm-description">
//                 {selectedLead.last_message ||
//                   "Добрый день! Интересует коммерческое предложение. Рассматриваем долгосрочное сотрудничество."}
//               </p>

//               <div className="crm-contact-actions">
//                 <button><Mail size={16} /> Email</button>
//                 <button><PhoneCall size={16} /> Телефон</button>
//                 <button><Send size={16} /> Telegram</button>
//                 <button><FileText size={16} /> Заметка</button>
//               </div>

//               <div className="crm-info-grid">
//                 <InfoRow icon={Building2} label="Компания" value={selectedLead.company_name || "—"} />
//                 <InfoRow icon={PhoneCall} label="Телефон" value={selectedLead.phone || "—"} />
//                 <InfoRow icon={Mail} label="Email" value={selectedLead.contact_email || "—"} />
//                 <InfoRow icon={MapPin} label="Город" value="Москва" />
//                 <InfoRow icon={Calendar} label="Добавлен" value={formatDate(selectedLead.created_at)} />
//               </div>

//               <div className="crm-detail-section">
//                 <div className="crm-section-title">Управление лидом</div>

//                 <label>Статус</label>
//                 <select
//                   value={editForm.status}
//                   onChange={e => setEditForm(f => ({ ...f, status: e.target.value }))}
//                 >
//                   {STATUSES.map(s => (
//                     <option key={s.key} value={s.key}>{s.label}</option>
//                   ))}
//                 </select>

//                 <label>Сумма, ₽</label>
//                 <input
//                   type="number"
//                   value={editForm.amount}
//                   onChange={e => setEditForm(f => ({ ...f, amount: e.target.value }))}
//                   min="0"
//                   step="1000"
//                 />

//                 <label>Когда позвонить</label>
//                 <input
//                   type="datetime-local"
//                   value={editForm.next_call_at}
//                   onChange={e => setEditForm(f => ({ ...f, next_call_at: e.target.value }))}
//                 />

//                 <label>Комментарий</label>
//                 <textarea
//                   value={editForm.last_comment}
//                   onChange={e => setEditForm(f => ({ ...f, last_comment: e.target.value }))}
//                   rows={3}
//                   placeholder="Что сказали, что договорились..."
//                 />

//                 <button className="crm-save-button" onClick={handleSave} disabled={savingId === selectedLead.id}>
//                   <Save size={16} />
//                   {savingId === selectedLead.id ? "Сохранение..." : "Сохранить изменения"}
//                 </button>
//               </div>

//               <div className="crm-detail-section">
//                 <div className="crm-section-title">
//                   История активности
//                 </div>

//                 <TimelineItem icon={Send} title="Письмо отправлено" date={formatDate(selectedLead.created_at)} />
//                 <TimelineItem icon={Eye} title="Открыто письмо" date="Сегодня, 16:45" />
//                 <TimelineItem icon={Link2} title="Переход по ссылке" date="Сегодня, 17:12" />
//                 <TimelineItem icon={MessageSquare} title="Ответ получен" date="Сегодня, 17:32" />
//               </div>

//               {selectedLead.conversation_id && (
//                 <div className="crm-detail-section crm-conversation">
//                   <div className="crm-section-title">
//                     <span>Переписка</span>
//                     <button onClick={reloadMessages} disabled={loadingMessages}>
//                       <RefreshCw size={14} className={loadingMessages ? "spin" : ""} />
//                     </button>
//                   </div>

//                   {loadingMessages ? (
//                     <div className="crm-muted">Загрузка…</div>
//                   ) : messages.length === 0 ? (
//                     <div className="crm-muted">Нет сообщений</div>
//                   ) : (
//                     <div className="crm-messages">
//                       {messages.map(m => (
//                         <div key={m.id} className={`crm-message ${m.sender === "me" ? "mine" : ""}`}>
//                           <small>
//                             {m.sender === "me" ? "Вы" : selectedLead.contact_email} · {formatDate(m.created_at)}
//                           </small>
//                           <p>{m.body}</p>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   <LeadReplyForm
//                     conversationId={selectedLead.conversation_id}
//                     contactEmail={selectedLead.contact_email}
//                     defaultSubject={selectedLead.subject}
//                     onSent={reloadMessages}
//                   />
//                 </div>
//               )}

//               <button className="crm-write-button">
//                 <Send size={17} />
//                 Написать
//               </button>
//               <button className="crm-campaign-button">
//                 <Plus size={17} />
//                 Добавить в кампанию
//               </button>
//             </aside>
//           )}
//         </section>

//         {/* BOTTOM ANALYTICS */}
//         <section className="crm-bottom-strip">
//           <div className="crm-bottom-main">
//             <div>
//               <span>Активные лиды</span>
//               <strong>{totalLeads || 1124}</strong>
//             </div>
//             <div className="mini-wave">
//               <i /><i /><i /><i /><i /><i /><i />
//             </div>
//           </div>

//           <BottomStat label="Сегодня" value={38} caption="новых лидов" />
//           <BottomStat label="В работе" value={stats.call || 12} caption="перешли в работу" />
//           <BottomStat label="Контакты" value={stats.invoice || 7} caption="связались" />
//           <BottomStat label="Сделки" value={stats.deal || 3} caption="закрыто" />

//           <div className="crm-bottom-request">
//             <div className="request-icon"><Mail size={17} /></div>
//             <div>
//               <span>Новая заявка</span>
//               <strong>{selectedLead?.contact_name || "Елена"} оставила заявку</strong>
//               <small>2 мин назад</small>
//             </div>
//             <ArrowUpRight size={17} />
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }

// function Metric({ icon: Icon, label, value, change, tone }) {
//   return (
//     <div className={`crm-metric ${tone}`}>
//       <div className="metric-icon"><Icon size={18} /></div>
//       <div className="metric-copy">
//         <span>{label}</span>
//         <strong>{value}</strong>
//         <small>↑ {change}</small>
//       </div>
//       <div className="metric-spark">
//         <i /><i /><i /><i /><i />
//       </div>
//     </div>
//   );
// }

// function InfoRow({ icon: Icon, label, value }) {
//   return (
//     <div className="crm-info-row">
//       <Icon size={14} />
//       <span>{label}</span>
//       <strong>{value}</strong>
//     </div>
//   );
// }

// function TimelineItem({ icon: Icon, title, date }) {
//   return (
//     <div className="crm-timeline-item">
//       <div className="timeline-icon"><Icon size={14} /></div>
//       <div>
//         <strong>{title}</strong>
//         <span>{date}</span>
//       </div>
//     </div>
//   );
// }

// function BottomStat({ label, value, caption }) {
//   return (
//     <div className="crm-bottom-stat">
//       <span>{label}</span>
//       <strong>{value}</strong>
//       <small>{caption}</small>
//     </div>
//   );
// }
